import { add, startOfWeek } from 'date-fns';
import produce from 'immer';
import {
  getWorkoutProgram,
  setDateRange,
  setLocation,
  setSelectedExercise,
} from './actions';

const startofWeek = startOfWeek(new Date());
const initialState = {
  dateRange: {
    startDate: startofWeek,
    endDate: add(startofWeek, { days: 6 }),
    key: 'selection',
  },
  location: null,
  workoutProgram: [],
  selectedExercise: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case getWorkoutProgram.SUCCESS:
      draft.workoutProgram = payload;
      break;
    case setDateRange.toString():
      draft.dateRange = payload;
      break;
    case setLocation.toString():
      draft.location = payload;
      break;
    case setSelectedExercise.toString():
      draft.selectedExercise = payload;
      break;
    // no default
  }
}, initialState);

export default reducer;
